import { Storage } from '@frameio/utils/storage/Storage';
import type {
  EnforceSerializable,
  Serializable,
  SerializableObject,
} from '@frameio/utils/types/utils';
import type { TransferBatchReactiveMapState } from '../client-schema/transfers/state/transferJobs';
import type { TransferJobTaskReactiveMapState } from '../client-schema/transfers/state/transferJobTasks';
import type {
  AssetDetailsPanelState,
  ClientCommentFilters,
  FavoriteTreeItem,
  LocalHashtag,
  LocalProjectFolderOpen,
  MediaState,
  MetadataFilter,
  ProjectFieldDefinition,
  SyncSession,
  UserPrefs,
} from '../generated';
import type { UndoRedoCommandHash } from '../graphql/features/undo-redo-demo/state';

export const graphqlClientStorage = new Storage<{
  [key: `reactive-state-${string}`]: Serializable;
  [key: `reactive-map-${string}`]: Serializable;
  'dev-apollo-logging': string;
}>();

/** declaration of all the reactive variables persisting in local storage and their shapes */
export type ReactiveStorage = EnforceSerializable<{
  'comment-filters': ClientCommentFilters;
  allSyncSessions: SyncSession[];
  recentInProjectSearches: string[];
  ephemeralFiltersMap: MetadataFilter[];
  devFlagsMap: boolean;
  featureFlagOverridesMap: boolean;
  copyPasteFieldsDemoMap: Array<ProjectFieldDefinition>;
  mediaStatesMap: MediaState[];
  'favorited-projects': string[];
  'favorited-assets': FavoriteTreeItem[];
  'opened-project-folders': LocalProjectFolderOpen[];
  'column-widths-fields': Record<string, number>;
  'column-widths-workspaces': Record<string, number>;
  hashtags: LocalHashtag[];
  syncSessionsMap: SyncSession;
  templateStates: SerializableObject;
  transferBatches: TransferBatchReactiveMapState;
  transferJobTasks: TransferJobTaskReactiveMapState;
  undoRedoCommandMap: UndoRedoCommandHash;
  userPrefsMap: UserPrefs;
  deleteAssetsTracker: string[];
  uploaderConfigsMap: number;
  assetDetailsPanelState: AssetDetailsPanelState;
  tempWorkspaceLayout: string;
  sequenceExports: SerializableObject;
  'workspaces-projects-scroll-position': SerializableObject;
}>;
